import React from "react";
import { CREDENTIAL_CATEGORY_LABELS } from "@toolkit/mobile-shared";
import { Badge } from "../../../components/ui/badge";
import { cn } from "../../../lib/utils";

export { CREDENTIAL_CATEGORY_LABELS };

const STATUS_LABEL: Record<string, string> = {
  valid: "Valid",
  expiring: "Expiring",
  expired: "Expired",
  no_expiry: "No expiry",
};

const STATUS_CLASS: Record<string, string> = {
  valid: "bg-emerald-50 text-emerald-700",
  expiring: "bg-amber-50 text-amber-800",
  expired: "bg-rose-50 text-rose-700",
  no_expiry: "bg-muted text-muted-foreground",
};

type CredentialStatusBadgeProps = {
  status?: string | null;
  className?: string;
};

export const CredentialStatusBadge: React.FC<CredentialStatusBadgeProps> = ({
  status,
  className,
}) => {
  const key = status || "valid";
  return (
    <Badge
      className={cn(
        "normal-case tracking-normal",
        STATUS_CLASS[key] ?? STATUS_CLASS.valid,
        className,
      )}
    >
      {STATUS_LABEL[key] ?? key}
    </Badge>
  );
};

export type { CredentialStatusBadgeProps };
